<template>
  <div class="popup-wrapper" @click.self="action.close">
    <div class="popup-action">
      <div class="button button-submit">
        <button class="btn" type="submit" name="note_order_settings"
          @click="action.delete"
        >決定
        </button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="action.close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span v-if="type === 'text'" class="hdg02">見出しの削除</span>
          <span v-else-if="type === 'textarea'" class="hdg02">コメントの削除</span>
          <span v-else-if="type === 'knowledge'" class="hdg02">最新ナレッジの削除</span>
          <span v-else-if="type === 'qa'" class="hdg02">Q&A・事例の削除</span>
          <span v-else-if="type === 'pj'" class="hdg02">資料の削除</span>
        </div>
        <div class="popup-content">
          <p v-if="type === 'text'" class="txt">この見出しを削除してもよろしいですか？</p>
          <p v-else-if="type === 'textarea'" class="txt">このコメントを削除してもよろしいですか？</p>
          <p v-else-if="type === 'knowledge'" class="txt">このノートに保存した最新ナレッジを削除してもよろしいですか？</p>
          <p v-else-if="type === 'qa'" class="txt">このノートに保存したQ&A・事例を削除してもよろしいですか？</p>
          <p v-else-if="type === 'pj'" class="txt">このノートに保存した資料を削除してもよろしいですか？</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'SPNotePartDeleteConfirm',
  props: {
    type: {
      default: null
    }
  },
  setup (props, context) {
    const store = context.root.$store
    const action = reactive({
      close: () => context.emit('close'),
      delete: () => context.emit('delete')
    })

    return {
      action
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    padding: 20px;
  }
}
</style>
